<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row>
        <v-col cols="12">
          <v-alert type="info" elevation="0" class="mb-0">
            <div
              class="font-weight-medium text-body-1 primary--text"
              v-for="message in messages"
              :key="message"
            >
              <span>{{ message }}</span>
            </div>
          </v-alert>
        </v-col>
        <v-col cols="12">
          <span class="font-weight-medium primary--text">Datos gráficos</span>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Logo desktop del broker"
            :rules="{
              required: broker.img_desktop ? false : true,
              ext: 'png',
              size: 300,
              max_dimensions: [300, 60]
            }"
            v-slot="{ errors }"
          >
            <v-file-input
              v-model="broker.desktop_file"
              :rules="rules"
              :accept="fileType"
              dense
              show-size
              outlined
              class="pt-3"
              label="Logo desktop del broker"
              @change="handleFile($event, 'desktop')"
              @click:clear="clearInputFile('desktop')"
              :error-messages="errors[0]"
            ></v-file-input>
          </ValidationProvider>
        </v-col>
        <v-col v-if="broker.img_desktop" cols="12" md="6">
          <div class="d-flex align-center">
            <v-label>Logo</v-label>
            <img
              class="broker-img ml-5 blue-grey lighten-4"
              :src="`data:image/png;base64,${broker.img_desktop}`"
              :alt="`Logo desktop ${broker.name}`"
            />
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Logo mobile del broker"
            :rules="{
              required: broker.img_mobile ? false : true,
              ext: 'png',
              size: 300,
              max_dimensions: [300, 60]
            }"
            v-slot="{ errors }"
          >
            <v-file-input
              v-model="broker.mobile_file"
              :rules="rules"
              :accept="fileType"
              dense
              show-size
              outlined
              class="pt-3"
              label="Logo mobile del broker"
              @change="handleFile($event, 'mobile')"
              @click:clear="clearInputFile('mobile')"
              :error-messages="errors[0]"
            ></v-file-input>
          </ValidationProvider>
        </v-col>
        <v-col v-if="broker.img_mobile" cols="12" md="6">
          <div class="d-flex align-center">
            <v-label >Logo</v-label>
            <img
              class="broker-img ml-5 blue-grey lighten-4"
              :src="`data:image/png;base64,${broker.img_mobile}`"
              :alt="`Logo mobile ${broker.name}`"
            />
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <ValidationProvider
            name="Background del broker"
            :rules="{
              required: broker.img_background ? false : true,
              ext: ['png', 'jpg'],
              size: 300,
              max_dimensions: [960, 1080]
            }"
            v-slot="{ errors }"
          >
            <v-file-input
              v-model="broker.background_file"
              :rules="rules"
              accept=".jpg,.png"
              dense
              show-size
              outlined
              class="pt-3"
              label="Background del broker"
              @change="handleFile($event, 'background')"
              @click:clear="clearInputFile('background')"
              :error-messages="errors[0]"
            ></v-file-input>
          </ValidationProvider>
        </v-col>
        <v-col v-if="broker.img_background" cols="12" md="6">
          <div class="d-flex align-center">
            <v-label>Background</v-label>
            <img
              class="broker-img ml-5 blue-grey lighten-4"
              :src="`data:image/png;base64,${broker.img_background}`"
              :alt="`Background ${broker.name}`"
            />
          </div>
        </v-col>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="3">
          <v-label class="primary--text">Color del tema</v-label>
          <v-text-field
            outlined
            v-model="broker.color"
            v-mask="mask"
            hide-details
            class="ma-0 pa-0"
            dense
          >
            <template v-slot:append>
              <v-menu
                v-model="menu"
                top
                nudge-bottom="105"
                nudge-left="16"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <div :style="swatchStyle" v-on="on" />
                </template>
                <v-card>
                  <v-card-text class="pa-0">
                    <ValidationProvider
                      name="Color del tema"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-color-picker
                        v-model="broker.color"
                        show-swatches
                        swatches-max-height="80"
                        flat
                        :error-messages="errors[0]"
                        mode="hexa"
                      />
                    </ValidationProvider>
                  </v-card-text>
                </v-card>
              </v-menu>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'

export default {
  components: { WizardForm },
  props: {
    broker: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      mask: '!#XXXXXX',
      menu: false,
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055'],
      ],
      rules: [
        value =>
          !value ||
          value.size < 300000 ||
          `El archivo debe pesar menos de 300KB`
      ],
      fileType: '.png',
      fileType2: '.png,.jpg',
      messages: [
        'El logo del broker debe estar en formato .png, no debe pesar más de 300kb y sus dimensiones máximas son 300px de ancho x 60px de alto.',
        'El background del broker debe estar en formato .png o .jpg, no debe pesar mas de 300kb y sus dimensiones máximas son 980px de ancho x 1080px de alto.'
      ]
    }
  },
  computed: {
    color() {
      return this.broker.color
    },
    swatchStyle() {
      const { color, menu } = this
      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '25px',
        width: '25px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    }
  },
  methods: {
    clearInputFile(type) {
      const index = this.broker.files.findIndex(
        (i) => i.type == type
      )
      this.broker.files.splice(index, 1)
    },
    handleFile(file, type) {
      if (file) {
        const fileSize = file.size
        const extension = `.${file.type.replace(/(.*)\//g, '')}`

        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.addEventListener('load', () => {
          const base64 = fr.result.split(',')[1]

          this.broker.files.push({
            extension: extension,
            nombre: file.name,
            file: base64,
            size: fileSize,
            type: type
          })
        })
      }
    },
  }
}
</script>
<style scoped>
.broker-img {
  width: 220px;
}
.divider {
  background-color: #2196F3FF;
}
</style>
